import {Component, input} from '@angular/core';
import {EvaluationSubCriteriaDirectus} from '@frontend/directus';
import {
  ProgressDashboardGenericTableComponent,
  TableConfig,
} from '../progress-dashboard-generic-table.component';
import {SubCriteriaAttributeItem} from '../../../subcriteria-attribute-evaluation/subcriteria-attribute-evaluation.types';

const SC_TABLE_CONFIG: TableConfig<EvaluationSubCriteriaDirectus> = {
  getNumberFromAttribute: (attribute) => attribute.scNumber,
  findCriteriaByNumber: (criteria, number) => criteria.find((sc) => sc.sc_number === number),
  getTranslations: (criteria) => criteria.translations,
  sortAscending: true,
};

@Component({
  selector: 'app-progress-dashboard-rfi-table',
  imports: [ProgressDashboardGenericTableComponent],
  template: `
    <app-progress-dashboard-generic-table
      [label]="label()"
      [subCriteriaAttributes]="subCriteriaAttributes()"
      [criteria]="subEvaluationCriteria()"
      [config]="tableConfig"
    />
  `,
})
export class ProgressDashboardRfiTableComponent {
  readonly label = input.required<string>();
  readonly subCriteriaAttributes = input.required<SubCriteriaAttributeItem[]>();
  readonly subEvaluationCriteria = input.required<EvaluationSubCriteriaDirectus[]>();

  protected readonly tableConfig = SC_TABLE_CONFIG;
}
